import { useEffect, useState } from "react";


function hexToRgb(hex) {
    if (hex === 'undefined') {
        return null;
    }

    let r = 0, g = 0, b = 0;

    if (hex.length == 4) {
      r = "0x" + hex[1] + hex[1];
      g = "0x" + hex[2] + hex[2];
      b = "0x" + hex[3] + hex[3];

    } else if (hex.length == 7) {
      r = "0x" + hex[1] + hex[2];
      g = "0x" + hex[3] + hex[4];
      b = "0x" + hex[5] + hex[6];
    }
    
    return ""+ +r + "," + +g + "," + +b;
}

export const Style = ({styles}) => {
    const [textColor, setTextColor] = useState(hexToRgb('#000000'));
    const [backgroundColor, setBackgroundColor] = useState(hexToRgb('#ffffff'));
    const [headerColor, setHeaderColor] = useState(hexToRgb('#ffffff'));

    useEffect(()=>{
        if (styles?.textColor) {
            setTextColor(hexToRgb(styles.textColor));
        }
        if (styles?.backgroundColor) {
            setBackgroundColor(hexToRgb(styles.backgroundColor));
        }
        if (styles?.headerColor) {
            setHeaderColor(hexToRgb(styles.headerColor));
        }
    }, [styles])

    return (
        <style>
        {`
        :root {
            --textColor: ${textColor};
            --backgroundColor: ${backgroundColor};
            --headerColor: ${headerColor};
        }

        body *:not(header *, .spinner-border, .btn, .history-nav-link) {
            color: rgb(var(--textColor))!important;
            background: rgb(var(--backgroundColor))!important;
            border-color: rgb(var(--textColor))!important;
            
        }

        body *:not(header *, footer *) {
            fill: rgb(var(--textColor))!important;
        }

        .btn {
            color: rgb(var(--backgroundColor))!important;
            background: rgb(var(--textColor))!important;
            border-radius: 5px;
            padding: 10px 15px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
        }



        header {
            color: rbg(var(--headerColor));
            border-color: rbg(var(--headerColor));
        }

        header svg {
            fill: rbg(var(--headerColor));
        }



        footer ul {
            box-shadow: 0 -15px 20px rgba(var(--textColor), 0.2);
        }

        footer ul .nav-link.сustom svg,
        footer ul .nav-link.сustom span {
            color: rgba(var(--textColor), 0.5)!important;
            fill: rgba(var(--textColor), 0.5);
        }
        
        footer ul .nav-link.сustom.active svg,
        footer ul .nav-link.сustom.active span {
            color: rgb(var(--textColor))!important;
            fill: rgb(var(--textColor));
        }

        footer ul .nav-link .cart-counter {
            z-index: 10;
            color: rgb(var(--backgroundColor))!important;
            background: rgb(var(--textColor))!important;
        }



        .order-nav-wrap,
        .submit-wrap {
            box-shadow: 0 -15px 20px rgba(var(--textColor), 0.2);
        }

        input::placeholder {
            color: rgb(var(--textColor))!important;
        }

        .form-check-input:checked {
            background-color: rgb(var(--textColor))!important;
            border-color: #0d6efd!important;
        }

        .modal-header .btn-close {
            fill: rgb(var(--textColor))!important;
            padding: 0;
            width: 50px;
            height: 50px;
        }

        .history-nav-link {
            background: rgb(var(--textColor))!important;
            color: rgb(var(--backgroundColor))!important;
        }
        
        .history-nav-link.active {
            background: rgb(var(--backgroundColor))!important;
            color: rgb(var(--textColor))!important;
        }

        .spinner-border {
            color: rgb(var(--textColor))!important;
        }

        .categories-list .category-item.active::after {
            background-color: rgb(var(--textColor))!important;
        }

        `}
      </style>
    )
}